export const TransportadoraTipoId = {
  OUTROS: 0,
  CORREIOS: 1,
  JAMEF: 2,
  JADLOG: 3,
  DIRECTLOG: 4,
  TOTAL_EXPRESS: 5,
  SSW: 6,
  SINCLOG: 7,
  BRUDAM: 8,
  CARRIERS: 9,
  OPENLOG: 10,
  MANDOU_BEM_LOG: 11,
  AZUL: 12,
  TRANSFOLHA: 13,
  DLOG: 14,
  INTERLOG: 15,
  FEDEX: 16,
  PLIMOR: 17,
  BRASPRESS: 18,
  RODOE: 19,
  SEQUOIA: 20,
  DAYTONA: 21,
  SIM_EXPRESS: 22,
  UELLO: 23,
  TRANSVILLE: 24,
  TRACK3R: 25,
  IS_ENTREGAS: 26,
  MELHOR_ENVIO: 27,
  JT_EXPRESS: 29,
  RETIRAR_LOJA: 30,
  FLIX_LOG: 31,
  SATURNO: 32,
  RODONAVES: 33,
  PORTAL_TRANSPORTES: 34,
  KANGU: 35,
  LOGGI: 36,
  MARKETPLACE: 37,
  SUPER_FRETE: 38,
  CALCULO_CALLBACK: 39,
  IMILE: 40,
  FM_TRANSPORTES: 41,
  MAGAZORD_ENVIOS_JT_EXPRESS: 42,
  SMART_ENVIOS: 43,
  LOGMANAGER: 44,
}